<template>
  <transition name="modal-scale">
    <div v-if="isOpen" class="modal-backdrop">
      <div class="modal">
        <div class="modal__wrapper">
          <div class="modal__header">
            <i @click="close" class="icon icon--x"></i>
          </div>
          <div class="modal__body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: rgba(black, 0.05); */
  z-index: 101;
}
.modal {
  position: relative;
  width: 100%;
  max-width: 50rem;
  background: white;
  border-radius: 1.5rem;
  box-shadow: $shadow_lg;
  &__wrapper {
    padding: 1em 1em 2em;
    @include bp(sm) {
      padding: 1em 2em 2em;
    }
  }
  &__header {
    display: flex;
    width: 100%;
    margin-bottom: 1em;
    i {
      margin-left: auto;
      transition: $transition;
      cursor: pointer;
      &:hover {
        transform: scale(1.25);
        transition: $transition;
      }
    }
  }
}
.modal-scale-enter,
.modal-scale-leave-active {
  transform: scale(0);
}
.modal-scale-enter-active,
.modal-scale-leave-active {
  transition: $transition;
}
</style>
